// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tgpp-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #6d6969;
  z-index: 99;
  height: 35px;
  padding: 5px 10px;
  color: white;
}
.tgpp-footer a {
  color: white;
}
.tgpp-footer .footer-underline-style:hover {
  cursor: pointer;
  text-decoration: underline;
}

.tgpp-app .topnav {
  overflow: hidden;
  background-color: #b4b4b4;
}
.tgpp-app .topnav a {
  float: left;
  color: black;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
  font-weight: lighter;
}
.tgpp-app .topnav a:hover {
  background-color: #ddd;
  color: black;
}
.tgpp-app .topnav a.active {
  font-weight: bold;
}
.tgpp-app .topnav-right {
  float: right;
}
.tgpp-app .tdrs-displayblock {
  display: block;
}
.tgpp-app .tdrs-displaymiddle {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.mat-drawer-content {
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./src/assets/styles/variable.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YCJc;EDKd,iBAAA;EACA,YAAA;AAAF;AACE;EACE,YAAA;AACJ;AAEE;EACE,eAAA;EACA,0BAAA;AAAJ;;AAKE;EACE,gBAAA;EACA,yBAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AAHJ;AAME;EACE,sBAAA;EACA,YAAA;AAJJ;AAOE;EACE,iBAAA;AALJ;AAQE;EACE,YAAA;AANJ;AASE;EACE,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AARJ;;AAaA;EACI,YAAA;AAVJ","sourcesContent":["@import '../assets/styles/variable.scss';\n.tgpp-footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  background-color: #6d6969;\n  z-index: 99;\n  height: $footer-height;\n  padding: 5px 10px;\n  color: white;\n  a {\n    color: white;\n  }\n\n  .footer-underline-style:hover{\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n.tgpp-app {\n  .topnav {\n    overflow: hidden;\n    background-color: #b4b4b4;\n  }\n  \n  .topnav a {\n    float: left;\n    color: black;\n    text-align: center;\n    padding: 14px 16px;\n    text-decoration: none;\n    font-size: 17px;\n    font-weight: lighter;\n  }\n  \n  .topnav a:hover {\n    background-color: #ddd;\n    color: black;\n  }\n  \n  .topnav a.active {\n    font-weight: bold;\n  }\n  \n  .topnav-right {\n    float: right;\n  }\n\n  .tdrs-displayblock {\n    display: block;\n  }\n\n  .tdrs-displaymiddle {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n}\n\n.mat-drawer-content {\n    padding: 0px;\n}","$brand-color: #c00;\n$header-height: 60px;\n$menu-tab-height: 48px;\n$footer-height: 35px;\n$link-color: #3f51b5;\n$review-not-begun:#c00;\n$review-in-process:#1495f1;\n$review-completed:#1aa520;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
